import React from "react";
import CostChart from "./CostChart";
import StatCard from "./StatCard";
import type { CostPeriod, SummaryCostEntry, SummaryData, Translate } from "../chatbotManagement.types";
import { formatCompact, formatSummaryCost } from "../chatbotManagement.utils";

interface ChatbotManagementStatsProps {
  summary: SummaryData | null;
  costPeriod: CostPeriod;
  setCostPeriod: (period: CostPeriod) => void;
  periodTokens: number;
  periodCost: number;
  costEntries: SummaryCostEntry[];
  t: Translate;
}

const PERIODS: CostPeriod[] = ["weekly", "lifetime"];

const ChatbotManagementStats = ({
  summary,
  costPeriod,
  setCostPeriod,
  periodTokens,
  periodCost,
  costEntries,
  t,
}: ChatbotManagementStatsProps): React.ReactElement | null => {
  if (!summary) return null;

  return (
    <>
      <div className="cbm-stats">
        <StatCard
          label={t("admin_chatbot_restaurants_enabled")}
          value={summary.restaurants_enabled}
          sub={summary.total_restaurants}
        />
        <StatCard label={t("admin_chatbot_active_this_week")} value={summary.active_this_week} />
        <StatCard
          label={t("admin_chatbot_period_tokens", {
            period: t(`admin_chatbot_period_${costPeriod}`),
          })}
          value={formatCompact(periodTokens)}
        />
        <StatCard
          label={t("admin_chatbot_period_cost", {
            period: t(`admin_chatbot_period_${costPeriod}`),
          })}
          value={formatSummaryCost(periodCost)}
        />
      </div>

      <div className="cbm-panel">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div className="cbm-panel-title">{t("admin_chatbot_cost_by_restaurant")}</div>
          <div
            className="cbm-period-toggle"
            style={{
              display: "flex",
              background: "#F1EFE8",
              borderRadius: 8,
              padding: 2,
              gap: 2,
            }}
          >
            {PERIODS.map((period) => (
              <button
                key={period}
                type="button"
                className="cbm-period-btn"
                onClick={() => setCostPeriod(period)}
                style={{
                  padding: "6px 14px",
                  borderRadius: 6,
                  fontSize: 13,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: "transparent",
                  cursor: "pointer",
                  transition:
                    "background 0.15s ease, color 0.15s ease, border-color 0.15s ease",
                  ...(costPeriod === period
                    ? {
                      background: "#fff",
                      color: "#E8792A",
                      fontWeight: 600,
                      border: "1px solid #F0997B",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                    }
                    : {
                      background: "transparent",
                      color: "#888780",
                      fontWeight: 400,
                    }),
                }}
              >
                {t(`admin_chatbot_period_${period}`)}
              </button>
            ))}
          </div>
        </div>
        <CostChart entries={costEntries} t={t} />
      </div>
    </>
  );
};

export default ChatbotManagementStats;
